import React, { useCallback, useEffect, useRef } from 'react';
import { TEXT, HEADING_LARGE, HEADING_MEDIUM, HEADING_SMALL } from './const';
import TextareaAutosize from 'react-textarea-autosize';

const textAreaStyle = {
  1: {
    fontSize: '14px',
    color: '#2D2926',
    fontWeight: 'normal',
    lineHeight: '24px',
  },
  2: { fontSize: '22px' },
  6: { fontSize: '20px' },
  7: { fontSize: '18px' },
};
const placeholder = {
  1: '本文を入力してください',
  2: '大見出しを入力してください',
  6: '中見出しを入力してください',
  7: '小見出しを入力してください',
};

const SectionText = ({
  index,
  content,
  userAgent,
  updateContent,
  isSelected,
  setSelectedIndex,
  deleteContent,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const element = inputRef.current;

    if (isSelected && element) {
      // autosize(element); // textareaの高さを自動調整するライブラリ
      element.focus(); // プレビューをクリックするとフォーカスが当たる
      element.setSelectionRange(element.value.length, element.value.length); // カーソルを末尾に移動
    }

    // return () => autosize.destroy(element);
  }, [isSelected]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === 'Backspace' && content.body === '') {
        e.preventDefault();
      }
    },
    [content]
  );

  const onScrollToFocus = useCallback(() => {
    if (userAgent !== 'pc') return;
    const element = inputRef.current;
    if (!element || !window) return;

    const textareaPosition = element.getBoundingClientRect();
    const desiredOffset = window.innerHeight / 3;
    const scrollOffset =
      textareaPosition.bottom - desiredOffset + window.scrollY;
    window.scrollTo({
      top: scrollOffset, // カーソル位置が画面上部に来るようにスクロール
      behavior: 'smooth',
    });
  }, [userAgent]);

  return (
    <div
      className="flex-grow-1"
      style={{ minHeight: '105px' }}
      onClick={() => !isSelected && setSelectedIndex(index)}
    >
      {isSelected ? (
        <div className="mt-2 pt-1">
          <TextareaAutosize
            id="body"
            className="textarea-no-border bg-white"
            style={{
              ...textAreaStyle[content.content_type],
              overflow: 'hidden',
              resize: 'none',
            }}
            value={content.body}
            onFocus={() => {
              onScrollToFocus();
            }}
            onChange={(e) => {
              updateContent({ ...content, body: e.target.value });
            }}
            onKeyDown={(e) => onKeyDown(e)}
            onBlur={() => {
              setSelectedIndex((prev) => (prev === index ? null : prev));
              if (
                !content.body ||
                !content.body.replace(/(\r\n|\n|\r)/gm, '')
              ) {
                deleteContent();
              }
            }}
            placeholder={placeholder[content.content_type]}
          />
        </div>
      ) : content.content_type === TEXT ? (
        <p
          cols="5"
          rows="6"
          className="py-2 w-100"
          style={{ whiteSpace: 'pre-line' }}
        >
          {content.body}
        </p>
      ) : content.content_type === HEADING_LARGE ? (
        <h2>{content.body}</h2>
      ) : content.content_type === HEADING_MEDIUM ? (
        <h3>{content.body}</h3>
      ) : content.content_type === HEADING_SMALL ? (
        <h4>{content.body}</h4>
      ) : null}
    </div>
  );
};

export default SectionText;
